// @ts-nocheck
import { EmployeeDto, StocktakeDto } from "@/PageComponents/Stock Take/StockTake.model";
import StocktakeForm from "@/PageComponents/Stock Take/StockTakeForm";
import { Box, Card, Flex } from "@mantine/core";
import React, { useContext, useEffect, useState } from "react";
import SCMessageBarContext from "@/utils/contexts/sc-message-bar-context";
import constants from "@/utils/constants";
import Breadcrumbs from "@/components/breadcrumbs";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { notifications } from "@mantine/notifications";
import StockService from "@/services/stock/stock-service";
import { useRouter } from "next/router";
import * as Enums from "@/utils/enums";
import Storage from "@/utils/storage";
import PermissionService from "@/services/permission/permission-service";
import Helper from "@/utils/helper";
import featureService from "@/services/feature/feature-service";
import employeeService from "@/services/employee/employee-service";
import { createFileRoute } from '@tanstack/react-router'

function CreateStocktakePage() {

    const router = useRouter();
    const { wid, empid: empidParam } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch
    const warehouseID = typeof wid === 'string' ? wid : undefined;
    const empid = typeof empidParam === 'string' ? empidParam : undefined;

    const { data: employee } = useQuery(
        ['employee', empid],
        () => employeeService.getEmployee(empid),
        { enabled: !!empid }
    );

    // Fetch the feature flag to check if stock take is enabled.
    // Redirect to home page if the feature is not available.
    const hasStockTakeQuery = useQuery(['hasStockTake'], () => featureService.getFeature(constants.features.STOCK_TAKE))

    // Redirect if stock take feature is not available
    useEffect(() => {
        if (hasStockTakeQuery.data === null) {
            router.replace('/');
        }
    }, [hasStockTakeQuery.data])

    const queryClient = useQueryClient();

    const stocktakeMutation = useMutation({
        mutationFn: StockService.postStockTake,
        onSuccess: (data: any) => {
            // Invalidate and refetch relevant queries
            queryClient.invalidateQueries({ queryKey: ['stocktake'] });

            notifications.show({
                // title: "Success",
                message: "Stock take has been created successfully",
                color: "scBlue"
            });

            router.replace(`/stock-take/${data.ID}`);
        },
        onError: (error: Error) => {
            notifications.show({
                title: "Error",
                message: error.message || "Failed to update stocktake",
                color: "yellow"
            });
        }
    });

    const messageBarContext = useContext(SCMessageBarContext);

    const onSubmit = (values: any) => {
        stocktakeMutation.mutate({ ...values, Status: Enums.StocktakeStatus.Pending } as StocktakeDto);
    }

    const onCancel = () => {
        router.replace('/inventory/list?tab=stocktake');
    }

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };

    const [stockAdmin] = useState(PermissionService.hasPermission(Enums.PermissionName.StockTakeManager));

    useEffect(() => {
        getAccessStatus();
    }, []);

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess || !stockAdmin) {
            Helper.nextRouter(router.replace, "/");
        }

    }, [accessStatus, stockAdmin]);

    const [stocktake, setStocktake] = useState<Partial<StocktakeDto>>({});

    const [active, setActive] = useState(0);

    return (
        <Box>
            <Flex h={28} align={'center'} px={'lg'}>
                <Breadcrumbs currPage={{ text: 'Create Stock Take', link: '/stock-take/create', type: 'create' }} />
            </Flex>
            <Box
                mih={`calc(100vh - 40px - 30px${((messageBarContext as any)?.isActive ? ` - ${constants.messageBarMargin}px` : "")})`}
                bg={'gray.1'}
                py={{ base: 0, lg: 'md', xl: 'lg' }}
            >
                <Card mx={'auto'} bg={'white'} p={'md'} mt={0} shadow={'xs'} radius={5} maw={1100}>
                    {/*<Stepper
                        active={active}
                        onStepClick={setActive}
                        completedIcon={<IconCircleCheck size={20} />}
                    >
                        <Stepper.Step
                            icon={<IconFileInfo size={20}/>}
                            label="Step 1"
                            description="Stock Take Details"
                        >
                            <StocktakeForm
                                submitting={stocktakeMutation.isLoading}
                                onSubmit={onSubmit}
                                onCancel={onCancel}
                                initialValues={stocktake}
                            />
                        </Stepper.Step>
                        <Stepper.Step
                            icon={<IconAssembly size={20}/>}
                            label="Step 2"
                            description="Select Item List Template"
                        >
                            <InventoryTransferList />
                        </Stepper.Step>
                        <Stepper.Step
                            icon={<IconClockPlay size={20}/>}
                            label="Step 3"
                            description="Set Schedule"
                        />
                    </Stepper>*/}

                    <StocktakeForm
                        submitting={stocktakeMutation.isLoading}
                        onSubmit={onSubmit}
                        onCancel={onCancel}
                        forWarehouseID={warehouseID}
                        capturer={employee}
                    />
                </Card>
            </Box>
        </Box>
    );
}

export default CreateStocktakePage;

export const Route = createFileRoute('/_authenticated/stock-take/create')({ component: CreateStocktakePage })
